<template>
    <div class="c-banner-wapper">
        <LayoutContent>
            <div class="banner-content">
                <div class="c-banner-text-box">
                    <h5 class="text-item is-title">{{ $t("main:客户端SDK下载") }}</h5>
                    <p class="text-item is-detail">{{ $t("main:兼容多种开发平台和游戏引擎，几行代码轻松接入，实现高品质游戏语音通话体验") }}</p>
                </div>
            </div></LayoutContent
        >
    </div>
</template>

<script>
import LayoutContent from "@/components/UI/LayoutContent.vue";
export default {
    name: "BannerSDK",
    components: { LayoutContent },
};
</script>

<style scoped lang="less">
.c-banner-wapper {
    display: flex;
    justify-content: center;
    position: relative;
    padding-top: 80px;
    padding-left: 24px;
    padding-right: 24px;
    margin-top: -80px;
    background: #151829 url(https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/sdk/banner-sdk.png) no-repeat center 4%;
    background-size: 1920px;
    .banner-content {
        display: flex;
        flex-direction: column;
        min-height: 520px;
    }
}
.c-banner-text-box {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-bottom: 28px;
    .text-item {
        &.is-title {
            font-size: 60px;
            font-weight: normal;
            letter-spacing: -0.4px;
            color: #fff;
        }
        &.is-detail {
            font-size: 18px;
            line-height: 1.8;
            letter-spacing: -0.6px;
            color: #a1a5af;
        }
        & + .text-item {
            margin-top: 16px;
        }
    }
}

@media only screen and (max-width: 1200px) {
    .c-banner-wapper {
        .banner-content {
            min-height: 320px;
        }
    }
    .c-banner-text-box {
        .text-item {
            &.is-title {
                font-size: 40px;
            }
            &.is-detail {
                font-size: 15px;
            }
        }
    }
}
@media only screen and (max-width: 768px) {
    .c-banner-wapper {
        br {
            display: none;
        }
        .banner-content {
            min-height: 240px;
        }
    }
    .c-banner-text-box {
        .text-item {
            &.is-title {
                font-size: 32px;
            }
            &.is-detail {
                line-height: 1.6;
            }
        }
    }
}
@media only screen and (max-width: 480px) {
    .c-banner-wapper {
        .banner-content {
            min-height: 320px;
        }
    }
    .c-banner-text-box {
        .text-item {
            &.is-title {
                font-size: 24px;
            }
        }
    }
}
</style>
